import type {
  DbmsDetailsResponse,
  DbmsResponse,
  GetDbmsDetailsRequestBody,
  RenameDbmsRequestBody,
  UnregisterDbmsRequestBody,
} from '../api-types';
import { transformGetDbmsDetailsResponse, transformGetDbmssResponse } from '../transformers/topology';
import type * as DeploymentTypes from '../types/topology';
import type { Builder } from './types';

const BASE_PATH = '/v1/user';

export const topologyEndpoints = (builder: Builder) => ({
  getDbmss: builder.query<DeploymentTypes.Dbms[], string>({
    query: (projectId) => ({
      url: `${BASE_PATH}/dbmss`,
      params: { projectId: projectId },
      headers: { 'Project-Id': projectId },
    }),
    providesTags: (result, error, projectId) => [{ type: 'Topology', id: projectId }],
    transformResponse: (res: DbmsResponse[]): DeploymentTypes.Dbms[] => transformGetDbmssResponse(res),
  }),
  getDbmsDetails: builder.query<DeploymentTypes.DbmsDetails, GetDbmsDetailsRequestBody>({
    query: (getDbmsDetailsRequest) => ({
      url: `${BASE_PATH}/dbmss/${getDbmsDetailsRequest.dbmsId}`,
      params: { projectId: getDbmsDetailsRequest.projectId },
      headers: { 'Project-Id': getDbmsDetailsRequest.projectId },
    }),
    providesTags: (result, error, getDbmsDetailsRequest) => [{ type: 'Topology', id: getDbmsDetailsRequest.dbmsId }],
    transformResponse: (res: DbmsDetailsResponse): DeploymentTypes.DbmsDetails => transformGetDbmsDetailsResponse(res),
  }),
  renameDbms: builder.mutation<boolean, RenameDbmsRequestBody>({
    query: (req) => ({
      url: `${BASE_PATH}/dbmss/${req.dbmsId}`,
      method: 'PATCH',
      params: { projectId: req.projectId },
      headers: { 'Project-Id': req.projectId },
      body: { name: req.name },
    }),
    invalidatesTags: (result, error, req) => [
      { type: 'Topology', id: req.projectId },
      { type: 'Topology', id: req.dbmsId },
    ],
  }),
  unregisterDbms: builder.mutation<boolean, UnregisterDbmsRequestBody>({
    query: (req) => ({
      url: `${BASE_PATH}/dbmss/${req.dbmsId}`,
      method: 'DELETE',
      params: { projectId: req.projectId },
      headers: { 'Project-Id': req.projectId },
    }),
    invalidatesTags: (result, error, req) => [
      { type: 'Topology', id: req.projectId },
      { type: 'Topology', id: req.dbmsId },
      { type: 'Tokens', id: req.projectId },
    ],
  }),
});
